export const apiError = (err_message, err_stack, func) => {
    return ({
        success: false,
        type: 'client-api',
        error: err_message,
        stack: err_stack,
        function: 'client-api: '+func,
    })
}